import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
@Component({
  selector: 'app-employee-salary-mapping',
  templateUrl: './employee-salary-mapping.component.html',
  styleUrls: ['./employee-salary-mapping.component.css']
})
export class EmployeeSalaryMappingComponent implements OnInit {
  EmployeeTypeList=[];
  Submitted:boolean=false;
  Designation=[];
  EmployeeList=[];
  SalaryComponentList=[];
  EmployeeCategoryList=[];

  constructor(private  payrollService: HrService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

  EmployeeSalaryMappingModel = {
    StaffID: 0,
    SalaryComponentID: 0,
    MonthlyEntitlement: 0,
    EmployeeCategoryID: 0,
    DesignationID: 0,
    StaffIdentity:'',
}

searchStaffModel = {
    StaffID: 0,
    PrimaryDepartmentID: 0,
    EmployeeCategoryID: 0,
    DesignationID: 0,
    StaffIdentity: '',  
}



      

SaveSalaryMapping  () {
    
        this.spinnerService.show();
        this.payrollService.SaveSalaryMapping(JSON.stringify(this.EmployeeList)).subscribe( (response:any)=> {   
        this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(response);
            this.GetAllEmployeeList();                   
        });            
};

GetAllEmployeeList  () {
  this.spinnerService.show();
    this.payrollService.GetAllEmployeeList(JSON.stringify(this.searchStaffModel)).subscribe( (data:any)=> {
  
        this.EmployeeList = data.EmployeeList;
        this.SalaryComponentList = data.SalaryComponentList;
     
       this.spinnerService.hide();


    });
};




Clear  () {
    this.searchStaffModel.EmployeeCategoryID = 0;
    this.searchStaffModel.DesignationID = 0;
    this.searchStaffModel.PrimaryDepartmentID = 0;
    this.searchStaffModel.StaffIdentity = '';
    this.EmployeeList = [];
    
}

  ngOnInit() {
    this.GetEmployeeCategory();
    this.GetDepartment();
    this.GetDesignation();
   
  }

 
GetEmployeeCategory() {
  this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;

  });
};
ListDepartment = []
GetDepartment() {
  this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
      this.ListDepartment = data.LookupItems;
  });

}

DesignationList = []
GetDesignation() {
  this.lookupservice.GetLookupsList('Designation', '').subscribe((data: any) => {
      this.DesignationList = data.LookupItems;
  });
};


}
